export const PROFESSIONAL_FONT_UNICODE_RANGE =
  "U+0000-024F, U+1E00-1EFF, U+2000-206F, U+2070-209F, U+20A0-20CF, U+2100-214F, U+2190-21FF, U+2200-22FF, U+25A0-25FF, U+2600-26FF, U+FEFF, U+FFFD";
